import {
    Decimal,
} from 'decimal.js';

import {
    ERROR,
} from './constants';

export function getMask(precision: number): RegExp[] {
    // цифры целой части + точка + цифры дробной части и необязательный минус в начале
    return [
        /[\d.-]/,
        ...new Array(precision + 1).fill(/[\d.]/),
    ];
}

export function checkValue(value: string, precision: number, scale: number, withNegative: boolean): boolean {
    const match = /^(-?)(\d*)(?:\.(\d*))?$/.exec(value);

    if (!match) {
        return false;
    }

    const [, sign, integerPart, fractionPart = ''] = match;

    if (sign && !withNegative) {
        return false;
    }

    return integerPart.replace(/^0+(?=\d)/, '').length <= precision - scale && fractionPart.length <= scale;
}

export function formatInitialValue(value: string | null): string {
    if (value === null) {
        return '';
    }

    // Убирает хвостовые нули значений numeric(precision, scale): "104.43000000" -> "104.43"
    return new Decimal(value).toFixed();
}

export function formatValue(value: string): string | null {
    if (!/\d/.test(value)) {
        return null;
    }

    return new Decimal(value.replace(/\.$/, '')).toFixed();
}

export function checkPositive(value: string): boolean {
    return new Decimal(value).greaterThan(0);
}

export function formatError(error: ERROR | null): string {
    switch (error) {
        case ERROR.IS_REQUIRED: {
            return 'Is required';
        }
        case ERROR.NOT_POSITIVE: {
            return 'Must be greater than zero';
        }
        case ERROR.IS_INCONSISTENT: {
            return 'Is inconsistent';
        }
        case null: {
            return '';
        }
    }
}
